export default "__VITE_ASSET__DgWKh3wQ__"